import React, { useEffect, useState } from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { Box, Typography } from '@mui/material';
import { UploadedStyle } from './style';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import Timer from './Timer';
import useUploadContext from '../../../../../../hooks/useUploadContext/useUploadContext';
import { detectMediaTypeFromUrl } from '../../../../../../utils/mediaDetection';

interface Uploaded {
  url: string;
  uploadedType: number;
  name: string;
  date: string;
}

interface UploadedListProps {
  onSelect: Function;
  value: number;
  index: number;
}

function UploadedList(props: UploadedListProps) {
  const { onSelect, value, index } = props;
  const { setPractitionerMediaType, setPractitionerMediaURI } = usePractitionerControlsContext();
  const { uploadedContainer } = UploadedStyle;
  const [localUploadedFiles, setLocalUploadedFiles] = useState([]);
  const { setIsExpiredTime } = useUploadContext();
  const [isUpdateTime, setIsUpdated] = useState<boolean>(false);

  useEffect(() => {
    setIsExpiredTime(true);
    let uploadedFiles = localStorage.getItem('uploadedList');

    if (!!uploadedFiles) {
      let parsedUploadedFiles = JSON.parse(uploadedFiles);
      let filteredFiles = parsedUploadedFiles.filter((file: any) => {
        let isExpired = checkIfExpired(file.date);
        return !isExpired;
      });
      localStorage.setItem('uploadedList', JSON.stringify(filteredFiles));
      setLocalUploadedFiles(filteredFiles);
    }
  }, [value, isUpdateTime]);

  const checkIfExpired = (expirationDate: string) => {
    let nowLocal = new Date();
    let expirationUTC = new Date(expirationDate);

    return nowLocal >= expirationUTC;
  };

  const onURLSelect = (url: string, type: number) => {
    const parsedType = Number(type);
    const restoredType = Number.isInteger(parsedType) ? parsedType : detectMediaTypeFromUrl(url);

    if (restoredType === null) {
      return;
    }

    setPractitionerMediaURI(url);
    setPractitionerMediaType(restoredType);
    onSelect();
  };

  const onRemoveItem = (removeKey: string) => {
    let uploadedFiles = localStorage.getItem('uploadedList');
    if (uploadedFiles) {
      let parsedUploadedFiles = JSON.parse(uploadedFiles);
      let updatedFiles = parsedUploadedFiles.filter((file: any) => {
        let fileName = file.name;
        let fileURL = file.url;
        let key = fileName + fileURL;
        return key !== removeKey;
      });
      localStorage.setItem('uploadedList', JSON.stringify(updatedFiles));
      setLocalUploadedFiles(updatedFiles);
      setPractitionerMediaURI('');
    }
  };

  const onExpiredUpdate = (expiredKey: string) => {
    onRemoveItem(expiredKey);
    setIsUpdated(prev => !prev);
  };

  return (
    <>
      {value === index && (
        <Box sx={uploadedContainer}>
          <ul className={'uploaded-list'}>
            {localUploadedFiles.map((uploaded: object) => {
              const { url, uploadedType, name, date } = uploaded as Uploaded;
              let key = name + url;
              return (
                <Box key={key} className={'item'}>
                  <Typography className={'item-text'}>{name}</Typography>
                  <Box className={'buttons-container'}>
                    <Box className="expiration-container">
                      <Timer fileDate={date} timeExpired={() => onExpiredUpdate(key)} />
                    </Box>
                    <IconButton className={'select-button'} onClick={() => onURLSelect(url, uploadedType)} color="info">
                      <PlayCircleFilledWhiteOutlinedIcon className={'select-icon'} />
                    </IconButton>
                    <IconButton className={'remove-button'} onClick={() => onRemoveItem(key)} color="info">
                      <DeleteOutlineIcon className={'remove-icon'} />
                    </IconButton>
                  </Box>
                </Box>
              );
            })}
          </ul>
        </Box>
      )}
    </>
  );
}

export default UploadedList;
